const InvalidSpSessionError = function(samlRequest) {
  this.samlRequest = samlRequest
}

InvalidSpSessionError.prototype = Object.create(Error.prototype)
InvalidSpSessionError.prototype.constructor = InvalidSpSessionError

export default InvalidSpSessionError


/** WEBPACK FOOTER **
 ** ./components/service-provider/invalid-sp-session-error.js
 **/